export var FontFamilyProp;
(function (FontFamilyProp) {
    FontFamilyProp["inherit"] = "inherit";
    FontFamilyProp["base"] = "system-ui";
    FontFamilyProp["title"] = "'trajan-pro-3', serif";
    FontFamilyProp["monospace"] = "monospace";
})(FontFamilyProp || (FontFamilyProp = {}));
